"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const tokenSchema = new mongoose_1.Schema({
    subscription_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Subscription",
        required: true,
    },
    owner_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "User",
        required: true,
        unique: true,
    },
    key_id: {
        type: String,
        required: true,
        unique: true,
    },
    key: {
        type: String,
        required: false,
        unique: true,
    },
    tokens_remaining: {
        type: Number,
        required: true,
    },
    tokens_used: {
        type: Number,
        required: true,
        default: 0
    },
}, { timestamps: true });
exports.default = (0, mongoose_1.model)("Token", tokenSchema, "api_tokens");
